import Vue from 'vue'
import Router from 'vue-router'
import Home from 'pages/home/home'
// import Products from 'pages/products/products'
import Qyjy from 'pages/qyjy/qyjy'
import Qyzh from 'pages/qyzh/qyzh'
import Spaq from 'pages/spaq/spaq'
import Support from 'pages/support/support'
import Ypjg from 'pages/ypjg/ypjg'
import Ypzh from 'pages/ypzh/ypzh'
import Ymzs from 'pages/ymzs/ymzs'
import Symzs from 'pages/symzs/symzs'
import Ymjz from 'pages/ymjz/ymjz'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      component: Home
    },
    // {
    //   path: '/products',
    //   component: Products
    // },
    {
      path: '/qyjy',
      component: Qyjy
    },
    {
      path: '/qyzh',
      component: Qyzh
    },
    {
      path: '/spaq',
      component: Spaq
    },
    {
      path: '/support',
      component: Support
    },
    {
      path: '/ypjg',
      component: Ypjg
    },
    {
      path: '/ypzh',
      component: Ypzh
    },
    {
      path: '/ymzs',
      component: Ymzs
    },
    {
      path: '/symzs',
      component: Symzs
    },
    {
      path: '/ymjz',
      component: Ymjz
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js